import typeToReducer from 'type-to-reducer';
import update from 'immutability-helper';
import { flow, find, keys, first, pick, merge } from 'lodash/fp';

import * as types from './types';

function setCurrentRavenUser(user) {
  const raven = window.Raven;
  if (raven) {
    raven.setUserContext(flow(
      pick(['id', 'username', 'location', 'userType']),
    )(user));
  }
}

function reduceUserData(state, action) {
  const { meta: { userId } = {}, payload: newUserData } = action;

  const targetUserId = userId || flow(keys, first)(newUserData);

  const newUser = newUserData[targetUserId];

  if (newUser.current) {
    setCurrentRavenUser(newUser);
  }

  return update(state, {
    [targetUserId]: {
      $apply: x => x || {},
      $merge: newUser,
    },
  });
}

const initialState = {};

export default typeToReducer({
  [types.USERS_MERGE]: (state, action) => {
    const { payload: newUsers } = action;
    return flow(
      merge(newUsers),
    )(state);
  },
  [types.USER_GET]: {
    FULFILLED: reduceUserData,
  },
  [types.EDUCATOR_CREATE]: {
    FULFILLED: reduceUserData,
    REJECTED: (state, action) => ({ ...state, errors: action.payload.response.data }),
  },
  [types.USER_CHANGE]: {
    FULFILLED: reduceUserData,
    PENDING: reduceUserData,
  },
  [types.USER_SELECT]: (state, action) => {
    const { meta: { userId } } = action;
    const selectedUserId = userId === 'current'
      ? flow(
        find({ current: true }),
        user => user.id,
      )(state)
      : userId;

    return update(state, {
      [selectedUserId]: {
        selected: { $set: true },
      },
    });
  },
  [types.STUDENT_CREATE]: {
    FULFILLED: reduceUserData,
    REJECTED: (state, action) => ({ ...state, errors: action.payload.response.data }),
  },
  [types.PROFESSIONAL_CREATE]: {
    FULFILLED: reduceUserData,
    REJECTED: (state, action) => ({ ...state, errors: action.payload.response.data }),
  },
}, initialState);
